<template>
    <div>
      <Main />
    </div>
  </template>
  
  <script>
  import Main from "../pradosur/mapLocation/Main.vue";
  
  export default {
    name: "Menu",
    components: {
      Main,
    },
  };
  </script>
  